
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruise",
      function () {
        return require("private-next-pages/cruise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruise"])
      });
    }
  